interface ModalProps {
  tall?: boolean
  compact?: boolean
  children: React.ReactNode
}

const ModalStripe: React.FunctionComponent<ModalProps> = ({
  tall,
  compact,
  children
}) => {
  const heightClass = compact === true
    ? 'min-h-0'
    : tall === true
      ? 'min-h-[min(600px,calc(100vh-140px))] sm:min-h-[min(750px,calc(100vh-140px))]'
      : 'min-h-[min(480px,calc(100vh-140px))] sm:min-h-[min(580px,calc(100vh-140px))]'

  return (
    <div className='bg-black flex justify-center items-start'>
      <div className='glow-effect'>
        <div className='diamond-corner p-[2px] sm:p-[4px] bg-dopage-lightGreen min-h-[300px] sm:min-h-[400px] w-full max-w-[670px]'>
          <div className={`inner bg-black flex flex-col ${heightClass}`} data-testid='modal-stripe-inner'>
            <div className='p-4 sm:p-[22px] flex flex-col items-center text-dopage-lightGreen flex-grow'>
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalStripe
